import React from "react";
import { formatRelative } from "date-fns";
import { enUS } from "date-fns/locale";
import S from "./DateSeparator.styled";
import { useTranslation } from "../../hooks";
const DateSeparator = ({ date }) => {
    const strings = useTranslation();
    const formatRelativeLocale = {
        lastWeek: strings.literalDayDateFns,
        yesterday: strings.yesterdayDateFns,
        today: strings.todayDateFns,
        other: strings.dateFns,
    };
    const locale = Object.assign(Object.assign({}, enUS), { formatRelative: (token) => formatRelativeLocale[token] });
    const relativeDate = formatRelative(new Date(date), new Date(), { locale });
    return (React.createElement(S.DateSeparator, { "data-testid": "date-separator" }, relativeDate));
};
export default DateSeparator;
//# sourceMappingURL=DateSeparator.js.map